const apiUrl = process.env.REACT_APP_API_URL
const apiUrlImg = process.env.REACT_APP_API_URL_IMG;
const apiTel = process.env.REACT_APP_API_URL_TELECHARGE;
const apiUrlCat = process.env.REACT_APP_API_URL_CATEGORIE;
const apiIdp = process.env.REACT_APP_API_IDP;

export { apiUrl, apiUrlImg, apiTel, apiUrlCat, apiIdp };